export class EnergyCategory {
  id: number;
  version: number;
  name: string;
  displayName: string;
}

export const MOBILITY_CATEGORY = 4;
